import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Nav.module.scss';
import Routes from '../../types/routes';
import NavItem from './NavItem';
import FoldNavItem from './FoldNavItem';

const Nav: React.FC = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const menuList = [
    {
      name: t('overview'),
      path: Routes.Dashboard,
      icon: 'iconOverview',
    },
    // {
    //   name: t('detail'),
    //   path: Routes.Detail,
    //   icon: 'iconDetail',
    // },
    {
      name: t('marketNav'),
      path: Routes.Market,
      icon: 'iconAnalysis',
    },
    {
      name: t('management'),
      path: 'manage_key',
      icon: 'iconManagement',
      children: [
        {
          name: t('wallet_management'),
          path: Routes.ManageWallet,
        },
        // {
        //   name: t('exchange_management'),
        //   path: Routes.ManageExchange,
        // },
        // {
        //   name: t('certificate_management'),
        //   path: Routes.Certificate,
        // },
        // {
        //   name: t('publish_api'),
        //   path: Routes.Publish,
        // },
      ],
    },
  ];
  return (
    <div className={styles.nav}>
      {menuList.map((menu) => {
        if (menu.children) {
          return (
            <FoldNavItem
              key={menu.path}
              label={menu.name}
              icon={menu.icon}
              sub={menu.children}
            />
          );
        }
        return (
          <Link key={menu.path} to={menu.path}>
            <NavItem
              active={pathname === menu.path}
              label={menu.name}
              icon={menu.icon}
            />
          </Link>
        );
      })}
    </div>
  );
};

export default Nav;
